import { Switch as SwitchPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Переключатель вкл/выкл (shadcn/ui). Подпись — `<label htmlFor>` или `aria-labelledby` рядом.
export const Switch = ({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) => (
  <SwitchPrimitive.Root
    data-slot="switch"
    className={cn(
      "inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full transition-colors outline-none focus-visible:ring-2 focus-visible:ring-accent/60 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent data-[state=unchecked]:bg-border",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      data-slot="switch-thumb"
      className="pointer-events-none block size-6 rounded-full transition-transform data-[state=checked]:translate-x-[22px] data-[state=checked]:bg-accent-foreground data-[state=unchecked]:translate-x-0.5 data-[state=unchecked]:bg-subtle"
    />
  </SwitchPrimitive.Root>
);
